module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNC4wNCAyNCI+PHRpdGxlPnVwLW88L3RpdGxlPjxwYXRoIGQ9Ik0xMiwzYTksOSwwLDEsMS05LDksOSw5LDAsMCwxLDktOW0wLTFBMTAsMTAsMCwxLDAsMjIsMTIsMTAsMTAsMCwwLDAsMTIsMloiLz48cGF0aCBkPSJNMTYsMTMuNWEuNTEuNTEsMCwwLDEtLjM2LS4xNUwxMiw5LjcxLDguMzcsMTMuMzVhLjUuNSwwLDAsMS0uNzEsMCwuNS41LDAsMCwxLDAtLjdsNC00YS41LjUsMCwwLDEsLjcxLDBsNCw0YS41LjUsMCwwLDEtLjM1Ljg1WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/up-circle-blue.svg
// module id = 1619
// module chunks = 1